import { ObjectizerModel } from '@leverege/condition';
const TYPE = 'condition.Variantizer';
function create(opts) {
  const defaultValue = opts?.defaultValue || null;
  const m = ObjectizerModel.create({
    defaultValue
  });
  m.type = TYPE;
  return m;
}
function variantFor(model, obj, context) {
  return ObjectizerModel.getValue(model, {
    ...context,
    target: obj
  });
}
export default {
  ...ObjectizerModel,
  create,
  variantFor,
  name: 'Variant By Condition',
  TYPE
};